import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import translationFR from "./locales/fr/translation.json";
import translationEN from "./locales/en/translation.json";
import { getDefaultLanguage } from "./utils/functions";

// the translations
// (tip move them in a JSON file and import them)
const resources = {
  fr: {
    translation: translationFR,
  },
  en: {
    translation: translationEN,
  },
};

i18n
  .use(initReactI18next) // passes i18n down to react-i18next
  .init({
    resources,
    lng: sessionStorage.getItem("language") || getDefaultLanguage(),
    fallbackLng: "fr",

    interpolation: {
      escapeValue: false, // react already safes from xss
    },
  });

export default i18n;
